import { LocationDto, MapsClient } from "@lib/ShiOneClient";
import type { AddressMapData } from "shared-ui/src/features/maps-feature/AddressMapProvider";
import type {
  LocationData,
  ShipmentMapData,
} from "shared-ui/src/features/maps-feature/ShipmentMapProvider";
import { ApiClientConfig } from "../../../../../auth/ApiClientConfig";

export interface AddressMapRequest {
  latitude: number;
  longitude: number;
  width?: number;
  height?: number;
}

export interface ShipmentMapRequest {
  biOrderId: string | number;
  trackingNumber: string;
  lastSeenLocation: string
  width?: number;
  height?: number;
}

const api = new MapsClient(ApiClientConfig, import.meta.env.API_ENDPOINT);

function toLocationData(location?: LocationDto): LocationData | null {
  if (!location) {
    return null;
  }
  return {
    latitude: location.latitude,
    longitude: location.longitude,
    pixelX: location.pixelX,
    pixelY: location.pixelY,
  };
}

export async function getAddressMap(request: AddressMapRequest): Promise<AddressMapData> {
  const dto = await api.getAddressMap(
    request.latitude,
    request.longitude,
    request.width,
    request.height
  );
  return {
    mapSasUrl: dto.mapSasUrl,
    centerLatitude: dto.latitude,
    centerLongitude: dto.longitude,
  };
}

export async function getShipmentMap(
  request: ShipmentMapRequest
): Promise<ShipmentMapData> {
  const dto = await api.getShipmentMap(
    Number(request.biOrderId),
    request.trackingNumber,
    request.lastSeenLocation,
    request.width ?? undefined,
    request.height ?? undefined,
  );
  return {
    mapSasUrl: dto.mapSasUrl,
    currentLocation: toLocationData(dto.currentLocation),
    destination: toLocationData(dto.destination),
    width: dto.width,
    height: dto.height,
  };
}
